export function getQueryFromArray(filter: string[]) {
  return filter.join(',');
}
